var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-center py-5 my-5 display-4 font-weight-bolder text-muted"},[_vm._v("Coming Soon")])])}]

export { render, staticRenderFns }